import { PropsWithChildren, createContext, useContext } from 'react';
import {
  LibraryCheckbox,
  LibraryCheckboxState,
  LearnWatchedItems,
} from '../types/library';

export type LibraryUserDataContextProps = {
  handleIsChecked: (learnNodeID: number) => boolean;
  checkboxes: LibraryCheckbox[];
  learnWatchedItems: LearnWatchedItems[];
};

const LibraryUserDataContext = createContext<LibraryUserDataContextProps>({
  handleIsChecked: () => false,
  checkboxes: [],
  learnWatchedItems: [],
});

type Props = {
  checkboxes: LibraryCheckbox[];
  learnWatchedItems: LearnWatchedItems[];
};

/**
 * QueueProvider.
 */
const LibraryUserDataProvider = (
  props: PropsWithChildren<Props>,
): JSX.Element => {
  const { children, checkboxes = [], learnWatchedItems = [] } = props;

  const handleIsChecked = (learnNodeID: number) => {
    return !!checkboxes.find(
      (checkbox) =>
        checkbox.nodeID === learnNodeID &&
        checkbox.state === LibraryCheckboxState.CHECKED,
    );
  };

  return (
    <LibraryUserDataContext.Provider
      value={{
        handleIsChecked,
        checkboxes,
        learnWatchedItems,
      }}
    >
      {children}
    </LibraryUserDataContext.Provider>
  );
};

/**
 * UseQueueContext.
 */
export const useLibraryUserDataContext = () =>
  useContext(LibraryUserDataContext);

export default LibraryUserDataProvider;
